import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
// Add the Firebase services that you want to use
// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
import { initializeApp } from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import { initializeFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import ReactDOM from 'react-dom';

/*
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
console.log(firebaseConfig);*/

const firebaseConfig = {
  apiKey: 'AIzaSyBoGiJ2LWfvOTeRunW2gxDc5ljwPoJf-L8',
  authDomain: 'specc-dev-ct2-energy-ayhix.firebaseapp.com',
  projectId: 'specc-dev-ct2-energy-ayhix',
  storageBucket: 'specc-dev-ct2-energy-ayhix.appspot.com',
  messagingSenderId: '497830664360',
  appId: '1:497830664360:web:9e79d1795441b97da28a9d',
  measurementId: 'G-15VVBJL3MQ',
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, {
  host: process.env.REACT_APP_FIREBASE_FIRESTORE_HOST || undefined,
  // ignoreUndefinedProperties: true,
  ssl: process.env.REACT_APP_FIREBASE_FIRESTORE_HOST ? false : undefined,
});
export const functions = getFunctions(app, 'asia-northeast1');
export const parentURI = 'https://specc-dev.riddler.co.jp';

ReactDOM.render(<App />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
